/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useEffect, useState} from 'react'
import {useAppDispatch, useAppSelector} from '../redux/hooks'
import {
  filterSelector,
  resetFilterMaterial,
  setFilterMaterial,
  setIsFetchData,
} from '../redux/slices/filterSlices'
import {fetchMaterials} from './fetcher'

export const useMaterialProducts = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [materialProducts, setMaterialProducts] = useState<any[]>([])
  const [numberUrls, setNumberUrls] = useState([])
  const [firstPage, setFirstPage] = useState('')
  const [lastPage, setLastPage] = useState('')

  const {filterMaterial: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const onFetchMaterialProducts = useCallback(async () => {
    try {
      setIsLoading(true)
      setIsError(false)

      const res = await fetchMaterials(filter)
      const {data, links, first_page_url, last_page_url} = res.data.data

      setMaterialProducts(data)
      setNumberUrls(links)
      setFirstPage(first_page_url)
      setLastPage(last_page_url)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
      dispatch(setIsFetchData(false))
    }
  }, [filter])

  const handlePageChange = (page: string | null) => {
    if (!page) return
    dispatch(setFilterMaterial({...filter, page: Number(page)}))
  }

  const handleReloadData = () => {
    dispatch(resetFilterMaterial())
    onFetchMaterialProducts()
  }

  useEffect(() => {
    const getter = setTimeout(onFetchMaterialProducts, 1000)
    return () => clearTimeout(getter)
  }, [onFetchMaterialProducts])

  useEffect(() => {
    return () => {
      dispatch(resetFilterMaterial())
    }
  }, [])

  return {
    isLoading,
    isError,
    materialProducts,
    numberUrls,
    firstPage,
    lastPage,
    handlePageChange,
    handleReloadData,
  }
}
